// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForwardMessageWithInfoPopup__forward-message-footer-f3933b {
  height: auto;
  min-height: 72px;
}

.ForwardMessageWithInfoPopup__forward-message-footer-f3933b.ForwardMessageWithInfoPopup__with-input-a07788 {
  padding-top: 8px;
  padding-bottom: 16px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ForwardMessageWithInfoPopup/ForwardMessageWithInfoPopup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;EACA,oBAAA;AACF","sourcesContent":[".forward-message-footer {\n  height: auto;\n  min-height: 72px;\n}\n\n.forward-message-footer.with-input {\n  padding-top: 8px;\n  padding-bottom: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"forward-message-footer": `ForwardMessageWithInfoPopup__forward-message-footer-f3933b`,
	"forwardMessageFooter": `ForwardMessageWithInfoPopup__forward-message-footer-f3933b`,
	"with-input": `ForwardMessageWithInfoPopup__with-input-a07788`,
	"withInput": `ForwardMessageWithInfoPopup__with-input-a07788`
};
module.exports = ___CSS_LOADER_EXPORT___;
